import { useMemo } from "react";
import { BurnTimeSeriesAnonymizedChartProps } from "./BurnTimeSeriesAnonymizedChart";
import { XAxis, ZoomOptions } from "@mui/x-charts-premium";
import { Duration } from "luxon";

export const useXAxis = (props: BurnTimeSeriesAnonymizedChartProps) => {
  return useMemo(() => {
    return {
      max: props.timeAxis?.maxDuration,
      tickInterval: tickInterval,
      zoom: props.timeAxis?.zoom
        ? ({
            slider: {
              enabled: true,
              preview: true,
            },
          } as ZoomOptions)
        : undefined,
    } as XAxis<"linear">;
  }, [props.timeAxis?.maxDuration, props.timeAxis?.zoom]);
};

const tickInterval = (duration: Duration): boolean => {
  if (duration <= Duration.fromDurationLike({ hours: 1 })) {
    return duration.as("minutes") % 15 === 0;
  }
  return duration.as("minutes") % 60 === 0;
};
